import { useOutletContext } from 'react-router-dom';
import { MobileNotificationsContextType } from '../mobile-notifications';
import { NotificationsList } from '../notifications-list/notifications-list';

export const MobileNotificationsReviews = () => {
  const { handleRemoveNotification, notifications, isLoading } =
    useOutletContext<MobileNotificationsContextType>();

  if (isLoading) return null;

  const filteredNotifications = notifications.filter((item) => item.type === 'review');

  return (
    <NotificationsList
      notifications={filteredNotifications}
      handleRemoveNotification={handleRemoveNotification}
    />
  );
};
